<div class="dialog-logging-container">
    <div class="message">
        <h4>Logging in, please wait…</h4>
    </div>
    <div class="loader">
        <cfi-spinner></cfi-spinner>
    </div>
</div>